import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { App } from '@app/core/models/app.model';
import { AppState } from '@app/core/states/app.state';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'rk-notification-form-platform-selector',
  templateUrl: './notification-form-platform-selector.component.html',
  styleUrls: ['./notification-form-platform-selector.component.scss'],
  standalone: false,
})
export class NotificationFormPlatformSelectorComponent implements OnInit, OnDestroy {
  isIphoneReady$: Observable<boolean> = inject(Store).select(AppState.isIphoneReady);
  isAndroidReady$: Observable<boolean> = inject(Store).select(AppState.isAndroidReady);
  currentApp$: Observable<App> = inject(Store).select(AppState.currentApp);
  @Input() platformControl: FormControl;
  @Input() iOSTooltipMessage = '';

  @Output() readonly platformToggle = new EventEmitter<string>();

  private readonly subscription = new Subscription();

  onTogglePlatform(platform: string): void {
    this.platformToggle.emit(platform);
  }

  ngOnInit(): void {
    const currentPlatforms = this.platformControl.value.value;

    this.subscription.add(
      this.isAndroidReady$.subscribe(isReady => {
        if (isReady && currentPlatforms?.length === 0) {
          this.platformToggle.emit('android');
        }
      }),
    );
    this.subscription.add(
      this.isIphoneReady$.subscribe(isReady => {
        if (isReady && currentPlatforms?.length === 0) {
          this.platformToggle.emit('iphone');
        }
      }),
    );

    this.subscription.add(
      this.currentApp$.subscribe(app => {
        this.iOSTooltipMessage = app.support.includes['iphone']
          ? marker('notification-form.tooltip-unavailable-ios')
          : marker('notification-form.tooltip-support-ios');
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
